<template>
  <admin-layout v-if="isAdmin">
    <lists slot="content"/>
  </admin-layout>
  <in-layout v-else>
    <lists class="mt-3" slot="content"/>
  </in-layout>
</template>

<script>
import InLayout from '@/layouts/InLayout';
import AdminLayout from '@/layouts/AdminLayout';
import Lists from '@/views/Lists'

export default {
  nanme: 'Tabs',
  components: {
    InLayout,
    AdminLayout,
    Lists,
  },
  computed: {
    isAdmin() {
      return this.$store.getters.currentUser.user_type === 'Admin';
    },
  },
}
</script>

<style lang="scss">
  .application-item {
    margin: .5rem 0 2rem;
  }

  .list-tabs {
    > .v-tabs__bar {
      & {
        background: none;
      }

      .v-tabs__wrapper {
        z-index: 2;
        position: relative;
        overflow: visible;

        &:after {
          z-index: 3;
          display: block;
          position: absolute;
          left: 0;
          bottom: -15px;
          width: 100%;
          height: 15px;
          background: #fff;
          content: "";
          transition: bottom ease .5s;
          transition-delay: .15s;
        }
      }

      .v-tabs__item {
        & {
          position: relative;
          padding: .5rem 1.5rem;
          background: #e0e0e0;
          font-size: 1.2rem;
          border-radius: 3px 3px 0 0;
        }

        &.v-tabs__item--active {
          & {
            background: #fff;
            box-shadow: 0 3px 15px rgba(0,0,0,.20);
          }
        }
      }
    }

    > .v-tabs__items {
      & {
        overflow: visible;
      }

      .v-tabs__content {
        transition: none !important;
      }
    }
}
</style>
